import { useDispatch } from 'react-redux';

import { pushSiteError } from 'containers/App/actions';

export const usePushSiteError = () => {
  const dispatch = useDispatch();
  return (message) => dispatch(pushSiteError({ message }));
};
